import React, { useState } from 'react';
import "./Navigation.css"
import Logo from "../assets/images/logo-iitgn.png"
import Logo1 from "../assets/images/logo.png"
import { FaBars, FaTimes } from 'react-icons/fa';
import { NavLink } from "react-router-dom";
import { SportsData } from '../data/SportsData';
// import SearchBar from './SearchBar';

const Navigation = () => {
    const [showMenu, setShowMenu] = useState(false);
    const handleToggle = () => {
        setShowMenu(!showMenu);
    };

    const handleLinkClick = () => {
        window.scrollTo(0, 0);
        setShowMenu(false);
    };
    return (
        <div className="navbar">
            <NavLink to="/" className="navbar__logo" onClick={() => window.scrollTo(0, 0)}>
                <img src={Logo1} alt="" />
            </NavLink>

            <button className="navbar__toggle" onClick={handleToggle}>

                {showMenu ? <FaTimes /> : <FaBars />}
            </button>
            <nav className={`nav ${showMenu ? 'show' : ''}`}>
                <div className="nav__content bd-grid">
                    <NavLink to="/" className="nav__perfil" onClick={handleLinkClick}>
                        <div className="nav__img">
                            <img src={Logo} alt="" />
                        </div>
                        <div>
                            <span className="nav__name">Sports at</span>
                            <span className="nav__name">IIT Gandhinagar</span>
                        </div>
                    </NavLink>


                    <div className="nav__menu">
                        <ul className="nav__list">
                            <li className="nav__item">
                                <NavLink to="/" className="nav__link" onClick={handleLinkClick}>
                                    Home
                                </NavLink>
                            </li>

                            <li className="nav__item dropdown">
                                <div className="nav__link dropdown__link">
                                    Sports
                                    <i className="bx bx-chevron-down dropdown__icon"></i>
                                </div>
                                <ul className="dropdown__menu">
                                <li className="dropdown__item">
                                                <NavLink to="/sports" className="nav__link" onClick={handleLinkClick}>
                                                    All
                                                </NavLink>
                                            </li>
                                    

                                    {SportsData.map((Sport, index) => {
                                        return (
                                            <li className="dropdown__item" key={index}>
                                                <NavLink to={`/sports/${Sport.SportsName}`} className="nav__link" onClick={handleLinkClick}>
                                                    {Sport.SportsName}
                                                </NavLink>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </li>

                            <li className="nav__item dropdown">
                                <div className="nav__link dropdown__link">
                                    Events
                                    <i className="bx bx-chevron-down dropdown__icon"></i>
                                </div>
                                <ul className="dropdown__menu">
                                   
                                    <li className="dropdown__item">
                                        <NavLink to="/events/leagues" className="nav__link" onClick={handleLinkClick}>
                                        Leagues
                                        </NavLink>
                                    </li>
                                    <li className="dropdown__item">
                                        <a href="https://students.iitgn.ac.in/hallabol-23/" target="_blank"  rel="noreferrer" className="nav__link">
                                        Hallabol
                                        </a>
                                    </li>
                                    <li className="dropdown__item">
                                        <NavLink to="/events/hosted-events" className="nav__link" onClick={handleLinkClick}>
                                        Events Hosted
                                        </NavLink>
                                    </li>
                                    <li className="dropdown__item">
                                        <NavLink to="/events/events-sponsors" className="nav__link" onClick={handleLinkClick}>
                                            Events Sponsors
                                        </NavLink>
                                    </li>
                                    <li className="dropdown__item">
                                        <NavLink to="/events/events-calendar" className="nav__link" onClick={handleLinkClick}>
                                            Events Calendar
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav__item">
                                <NavLink to="/team" className="nav__link" onClick={handleLinkClick}>

                                    Our Team

                                </NavLink>
                            </li>
                            <li className="nav__item">
                                <NavLink to="/contact" className="nav__link" onClick={handleLinkClick}>

                                    Contact Us

                                </NavLink>
                            </li>
                            {/* <li className="nav__item">
                                

                                   <SearchBar/>

                                
                            </li> */}
                        </ul>
                    </div>
                </div>
            </nav>
        </div>

    )
}

export default Navigation
